import { render, staticRenderFns } from "./ValuePriceWithCurrency.vue?vue&type=template&id=acd20d5a"
import script from "./ValuePriceWithCurrency.vue?vue&type=script&lang=js"
export * from "./ValuePriceWithCurrency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports